<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Schutz mit System und Stil</h2>
        <div class="flex justify-center">
          <h1 class="headline">Carports</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Ein Carport schützt nicht nur Ihr Fahrzeug, er trägt zur Werterhaltung bei, schafft Ordnung und wertet Ihr Grundstück sichtbar auf. Gleichzeitig ist er oft das Erste, was Besucher sehen. Grund genug, bei der Planung auf Funktion, Optik und Qualität zu setzen.
        </p>

        <p class="mt-4 text-gray-700">
          Wir fertigen Carports individuell nach Ihren Anforderungen, wahlweise offen oder mit seitlicher Verkleidung als Witterungs- und Sichtschutz. Für das Dach stehen verschiedene Varianten zur Verfügung: abgedichtet als Wanne mit Begrünung oder Bekiesung, lichtdurchlässige Glasscheiben in klar, matt oder farbig oder ein klassisches Blechdach. Auch die Integration einer Photovoltaikanlage ist grundsätzlich möglich, sprechen Sie uns gerne an.
        </p>

        <p class="mt-4 text-gray-700">
          Für maximale Langlebigkeit werden alle Carports feuerverzinkt. Auf Wunsch veredeln wir die Oberfläche zusätzlich durch eine Pulverbeschichtung in der Farbe Ihrer Wahl. So wird aus einer praktischen Überdachung ein durchdachtes Gestaltungselement, das perfekt zu Ihrem Zuhause passt.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Carports" pixelEvent="FormCarportsSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/carports/1.jpg", alt: "Carport 1" },
        { src: "img/produkte/carports/3.jpg", alt: "Carport 3" },
        { src: "img/produkte/carports/5.jpg", alt: "Carport 5" },
        { src: "img/produkte/carports/6.jpg", alt: "Carport 6" },
        { src: "img/produkte/carports/8.jpg", alt: "Carport 8" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
